'use client';

import { FC } from 'react';

import { Button, Grid, Heading } from '@purpur/library';
import { Icon } from '@purpur/library/icon';
import { chevronLeft } from '@purpur/library/icon/assets/chevron-left';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { GoBackContainer, PageHeader } from './ComparisonPage.styles';
import { ComparisonTable } from './ComparisonTable/ComparisonTable';

type Props = {
    categoryPath: string;
    categoryName?: string;
};

export const ComparisonPage: FC<Props> = ({ categoryPath, categoryName }) => {
    const { t } = useTranslations();

    const handleGoBack = () => {
        window.location.assign(categoryPath);
    };

    return (
        <Grid noGap={true}>
            <PageHeader>
                <GoBackContainer>
                    <Button variant="text" onClick={handleGoBack}>
                        <Icon svg={chevronLeft} size="xs" />
                        {t['eshop.comparison.go_back']}
                    </Button>
                </GoBackContainer>
                <Heading variant="title-300" tag="h1">
                    {t['eshop.comparison.title']}
                </Heading>
            </PageHeader>
            <ComparisonTable categoryPath={categoryPath} categoryName={categoryName} />
        </Grid>
    );
};
